const categories = [
    {name: 'Apartments Estepona', url: '/apartments-estepona'},
    {name: 'Apartments Marbella', url: '/apartments-marbella'},
    {name: 'Houses Marbella', url: '/houses-marbella'},
    // {name: 'Apartments Nerja', url: '/nerja'},
    // {name: 'Köpa hus i Malaga', url: '/kopa-hus-i-malaga'},
    // {name: 'Lägenhet i Malaga', url: '/apartments-malaga'},
]

export default categories